import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c('h2',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('myCommunities')))]),_c('ClubModule'),_c(VDivider,{staticClass:"my-5"}),_c('h2',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.$t('sharedJournal')))]),_c('SharingModule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }